export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '实行信息科技',

    /** 公司名称 */
    name: '合肥实行信息科技有限公司',
    /** 公司微信 */
    wechat: '',
    /** 公司邮箱 */
    email: 'king@kingcer.net',
    /** 公司手机 */
    phone: '021-61600119',
    /** 公司电话 */
    tel: '021-61600119',
    /** 公司地址 */
    address: '浦东新区xxx大厦1号楼5楼703',
    /** 备案号 */
    keepOnRecordIcp: '沪ICP备xxx号',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 121.526896,
        latitude: 31.24022,
        title: 'xxx大厦',
        address: '浦东新区xxx大厦1号楼5楼xxx'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js